var base;

if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

if ((base = window.CountdownTimer).current == null) {
  base.current = {};
}

CountdownTimer.init = function(arg, done) {
  var endAt, ref, timerData, timerModel, timerView;
  timerData = arg.timerData;
  if (done == null) {
    done = function() {};
  }
  endAt = timerData != null ? (ref = timerData.expiringSoon) != null ? ref.endAt : void 0 : void 0;
  if (!endAt) {
    return done();
  }
  timerModel = new CountdownTimer.Model({
    endAt: endAt
  });
  window.CountdownTimer.current.timerModel = timerModel;
  window.CountdownTimer.current.timerView = new CountdownTimer.View({
    model: timerModel,
    i18n: I18n.scoped(),
    el: timerData != null ? timerData.el : void 0,
    translationScope: timerData != null ? timerData.translationScope : void 0
  });
  timerView = window.CountdownTimer.current.timerView;
  return $(function() {
    timerView.render();
    return done();
  });
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9ncm91cG9uLWRlYWwtdGltZXIvcmVzcG9uc2l2ZS9mcm9udGVuZC9jb3VudGRvd25fdGltZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9ncm91cG9uLWRlYWwtdGltZXIvcmVzcG9uc2l2ZS9mcm9udGVuZC9jb3VudGRvd25fdGltZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtBLElBQUE7OztFQUFBLE1BQU0sQ0FBQyxpQkFBa0I7Ozs7TUFDSixDQUFDLFVBQVc7OztBQUVqQyxjQUFjLENBQUMsSUFBZixHQUFzQixTQUFDLEdBQUQsRUFBYyxJQUFkO0FBQ3BCLE1BQUE7RUFEc0IsWUFBRDs7SUFBYSxPQUFPLFNBQUEsR0FBQTs7RUFDekMsS0FBQSxtRUFBK0IsQ0FBRTtFQUNqQyxJQUFBLENBQXFCLEtBQXJCO0FBQUEsV0FBTyxJQUFBLENBQUEsRUFBUDs7RUFFQSxVQUFBLEdBQWEsSUFBSSxjQUFjLENBQUMsS0FBbkIsQ0FDWDtJQUFBLEtBQUEsRUFBTyxLQUFQO0dBRFc7RUFHYixNQUFNLENBQUMsY0FBYyxDQUFDLE9BQU8sQ0FBQyxVQUE5QixHQUEyQztFQUUzQyxNQUFNLENBQUMsY0FBYyxDQUFDLE9BQU8sQ0FBQyxTQUE5QixHQUEyQyxJQUFJLGNBQWMsQ0FBQyxJQUFuQixDQUN6QztJQUFBLEtBQUEsRUFBTyxVQUFQO0lBQ0EsSUFBQSxFQUFNLElBQUksQ0FBQyxNQUFMLENBQUEsQ0FETjtJQUVBLEVBQUEsc0JBQUksU0FBUyxDQUFFLFdBRmY7SUFHQSxnQkFBQSxzQkFBa0IsU0FBUyxDQUFFLHlCQUg3QjtHQUR5QztFQU0zQyxTQUFBLEdBQVksTUFBTSxDQUFDLGNBQWMsQ0FBQyxPQUFPLENBQUM7U0FFMUMsQ0FBQSxDQUFFLFNBQUE7SUFDQSxTQUFTLENBQUMsTUFBVixDQUFBO1dBQ0EsSUFBQSxDQUFBO0VBRkEsQ0FBRjtBQWpCb0IifQ==
